/**
 * Replace the numeric portion of a pre-formatted displayed price with a new
 * total, preserving the currency symbol position and decimal style.
 *   reformatDisplayedPrice('$130.00', 138) -> '$138.00'
 *   reformatDisplayedPrice('130 €',  138) -> '138.00 €'
 *   reformatDisplayedPrice('€130',   138) -> '€138'
 */
export const reformatDisplayedPrice = (
    displayed: string,
    total: number,
): string => {
    const match = displayed.match(/-?\d+(?:[.,]\d+)?/);
    if (!match) {
        return displayed;
    }
    const original = match[0];
    const hasDecimals = /[.,]/.test(original);
    const next = hasDecimals ? total.toFixed(2) : String(total);
    return displayed.replace(original, next);
};
